// import React from "react";
// import { Box, Container, Grid, Typography, IconButton } from "@mui/material";
// import PhoneRoundedIcon from "@mui/icons-material/PhoneRounded";
// import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
// import LocationOnRoundedIcon from "@mui/icons-material/LocationOnRounded";

// const NAVY = "#1B1F3B"; const CORAL = "#FF6B6B"; const YELLOW = "#FFD93D"; const TEAL = "#06D6A0"; const CREAM = "#FFF8F0";

// const Footer = ({ schoolInfo, navItems, onNavigate }) => (
//   <Box sx={{ backgroundColor: NAVY, borderTop: `4px solid ${YELLOW}`, pt: 8, pb: 4 }}>
//     <Container maxWidth="xl">
//       <Grid container spacing={5}>
//         {/* Brand */}
//         <Grid item xs={12} md={4}>
//           <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2 }}>
//             <Box component="img" src="/school-logo.png" alt="Logo" sx={{ width: 50, height: 50, borderRadius: "50%", border: `2.5px solid ${YELLOW}`, backgroundColor: "#fff", p: 0.4, objectFit: "contain" }} />
//             <Box>
//               <Typography sx={{ fontFamily: "'Fredoka One', cursive", fontSize: "1.3rem", color: YELLOW, lineHeight: 1.1 }}>St Lord's</Typography>
//               <Typography sx={{ fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700, fontSize: "0.65rem", color: CORAL, letterSpacing: "0.08em", textTransform: "uppercase" }}>Int'l Public School</Typography>
//             </Box>
//           </Box>
//           <Typography sx={{ color: "rgba(255,248,240,0.72)", fontSize: "0.9rem", lineHeight: 1.9, fontWeight: 600, maxWidth: 320 }}>
//             Nurturing curious minds, building confident futures. A joyful school community in the heart of Bangalore.
//           </Typography>
//           <Box sx={{ display: "flex", gap: 1, mt: 2.5 }}>
//             {["🎓", "📚", "🏆"].map((e, i) => (
//               <Box key={i} sx={{ width: 38, height: 38, borderRadius: "10px", border: `2px solid ${YELLOW}`, display: "grid", placeItems: "center", fontSize: "1.1rem", backgroundColor: "rgba(255,211,61,0.08)", animation: `floatY ${2 + i * 0.5}s ease-in-out infinite` }}>{e}</Box>
//             ))}
//           </Box>
//         </Grid>

//         {/* Quick Links */}
//         <Grid item xs={6} md={2}>
//           <Typography sx={{ fontFamily: "'Fredoka One', cursive", fontSize: "1.1rem", color: YELLOW, mb: 2 }}>Quick Links</Typography>
//           {navItems.map((item) => (
//             <Box key={item.id} component="button" onClick={() => onNavigate(item.id)}
//               sx={{ display: "block", width: "100%", textAlign: "left", background: "none", border: "none", cursor: "pointer", color: "rgba(255,248,240,0.75)", fontFamily: "'Nunito', sans-serif", fontWeight: 700, fontSize: "0.9rem", mb: 1, p: 0, transition: "color 0.2s", "&:hover": { color: CORAL } }}>
//               › {item.label}
//             </Box>
//           ))}
//         </Grid>

//         {/* Boards */}
//         <Grid item xs={6} md={2}>
//           <Typography sx={{ fontFamily: "'Fredoka One', cursive", fontSize: "1.1rem", color: YELLOW, mb: 2 }}>We Offer</Typography>
//           {["CBSE Board", "State Board", "Primary School", "Middle School", "High School", "Higher Secondary"].map((t) => (
//             <Typography key={t} sx={{ color: "rgba(255,248,240,0.7)", fontWeight: 700, fontSize: "0.87rem", mb: 0.8 }}>✓ {t}</Typography>
//           ))}
//         </Grid>

//         {/* Contact */}
//         <Grid item xs={12} md={4}>
//           <Typography sx={{ fontFamily: "'Fredoka One', cursive", fontSize: "1.1rem", color: YELLOW, mb: 2 }}>Get In Touch</Typography>
//           {[
//             { icon: <LocationOnRoundedIcon sx={{ fontSize: 18 }} />, text: schoolInfo.addressLines.join(", "), color: TEAL },
//             { icon: <PhoneRoundedIcon sx={{ fontSize: 18 }} />, text: schoolInfo.phone, color: CORAL },
//             { icon: <EmailRoundedIcon sx={{ fontSize: 18 }} />, text: schoolInfo.email, color: YELLOW },
//           ].map((c, i) => (
//             <Box key={i} sx={{ display: "flex", gap: 1.5, alignItems: "flex-start", mb: 2 }}>
//               <Box sx={{ mt: 0.2, color: c.color, flexShrink: 0 }}>{c.icon}</Box>
//               <Typography sx={{ color: "rgba(255,248,240,0.78)", fontWeight: 600, fontSize: "0.88rem", lineHeight: 1.6 }}>{c.text}</Typography>
//             </Box>
//           ))}
//         </Grid>
//       </Grid>

//       {/* Bottom bar */}
//       <Box sx={{ mt: 6, pt: 3, borderTop: "2px solid rgba(255,211,61,0.2)", display: "flex", flexWrap: "wrap", gap: 2, justifyContent: "space-between", alignItems: "center" }}>
//         <Typography sx={{ color: "rgba(255,248,240,0.5)", fontWeight: 700, fontSize: "0.8rem" }}>
//           © {new Date().getFullYear()} St Lord's International Public School, Bangalore. All rights reserved.
//         </Typography>
//         <Box sx={{ display: "flex", gap: 1 }}>
//           {[CORAL, YELLOW, TEAL].map((c, i) => (
//             <Box key={i} sx={{ width: 10, height: 10, borderRadius: "50%", backgroundColor: c, animation: `blink ${1 + i * 0.3}s ease-in-out infinite` }} />
//           ))}
//         </Box>
//       </Box>
//     </Container>
//   </Box>
// );

// export default Footer;

















import React from "react";
import { Box, Container, Grid, Typography, IconButton, Button } from "@mui/material";
import PhoneRoundedIcon from "@mui/icons-material/PhoneRounded";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import LocationOnRoundedIcon from "@mui/icons-material/LocationOnRounded";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import SchoolIcon from "@mui/icons-material/School";
import AndroidIcon from "@mui/icons-material/Android";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";

const NAVY = "#1B1F3B";
const CORAL = "#FF6B6B";
const YELLOW = "#FFD93D";
const TEAL = "#06D6A0";
const CREAM = "#FFF8F0";
const PURPLE = "#845EF7";
const ORANGE = "#FF9F1C";

const Footer = ({ schoolInfo, navItems, onNavigate }) => (
  <Box sx={{
    backgroundColor: NAVY,
    borderTop: `5px solid ${YELLOW}`,
    pt: { xs: 7, md: 9 },
    pb: 4,
    position: "relative",
    overflow: "hidden",
  }}>
    {/* Decorative elements */}
    <Box sx={{ position: "absolute", top: 30, right: 30, fontSize: "60px", opacity: 0.04, animation: "floatY 4s ease-in-out infinite" }}>📚</Box>
    <Box sx={{ position: "absolute", bottom: 40, left: 20, fontSize: "50px", opacity: 0.04, animation: "floatY 3.5s ease-in-out infinite" }}>🎓</Box>
    <Box sx={{ position: "absolute", top: "50%", right: "10%", fontSize: "40px", opacity: 0.03, animation: "starSpin 5s linear infinite" }}>⭐</Box>

    {/* Top wave pattern */}
    <Box sx={{
      position: "absolute",
      top: -1,
      left: 0,
      right: 0,
      height: "20px",
      background: `repeating-linear-gradient(45deg, ${YELLOW}20 0px, ${YELLOW}20 10px, transparent 10px, transparent 20px)`,
    }} />

    <Container maxWidth="xl" sx={{ position: "relative" }}>
      <Grid container spacing={5}>
        {/* Brand */}
        <Grid item xs={12} md={4}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2.5 }}>
            <Box
              component="img"
              src="/school-logo.png"
              alt="Logo"
              sx={{
                width: 56,
                height: 56,
                borderRadius: "50%",
                border: `3px solid ${YELLOW}`,
                backgroundColor: "#fff",
                p: 0.5,
                objectFit: "contain",
                boxShadow: `3px 3px 0 ${YELLOW}40`,
                animation: "wiggle 3s ease-in-out infinite",
              }}
            />
            <Box>
              <Typography sx={{
                fontFamily: "'Fredoka One', cursive",
                fontSize: "1.4rem",
                color: YELLOW,
                lineHeight: 1.1,
                textShadow: "0 2px 4px rgba(0,0,0,0.3)",
              }}>
                St Lord's
              </Typography>
              <Typography sx={{
                fontFamily: "'Space Grotesk', sans-serif",
                fontWeight: 800,
                fontSize: "0.7rem",
                color: CORAL,
                letterSpacing: "0.1em",
                textTransform: "uppercase"
              }}>
                Int'l Public School
              </Typography>
            </Box>
          </Box>

          <Typography sx={{
            color: "rgba(255,248,240,0.75)",
            fontSize: "0.92rem",
            lineHeight: 1.9,
            fontWeight: 600,
            maxWidth: 340,
            mb: 3,
          }}>
            Nurturing curious minds, building confident futures. A joyful school community in the heart of Bangalore.
          </Typography>

          {/* Quick action buttons */}
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 3 }}>
            {[
              { label: "Campus", url: "https://campus.stlordsinternationalpublicschool.com", icon: <SchoolIcon sx={{ fontSize: 16 }} />, color: TEAL },
              { label: "APK", url: "#", icon: <AndroidIcon sx={{ fontSize: 16 }} />, color: PURPLE },
              { label: "CRM", url: "https://leads.stlordsinternationalpublicschool.com", icon: <SupportAgentIcon sx={{ fontSize: 16 }} />, color: CORAL },
            ].map((link, i) => (
              <Button
                key={i}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                startIcon={link.icon}
                endIcon={<OpenInNewIcon sx={{ fontSize: 12 }} />}
                size="small"
                sx={{
                  backgroundColor: `${link.color}20`,
                  border: `1.5px solid ${link.color}60`,
                  color: link.color,
                  borderRadius: "8px",
                  fontFamily: "'Space Grotesk', sans-serif",
                  fontWeight: 700,
                  fontSize: "0.75rem",
                  textTransform: "none",
                  px: 1.5,
                  py: 0.5,
                  transition: "all 0.2s ease",
                  "&:hover": {
                    backgroundColor: `${link.color}35`,
                    border: `1.5px solid ${link.color}`,
                    transform: "translateY(-1px)",
                  },
                }}
              >
                {link.label}
              </Button>
            ))}
          </Box>

          {/* Fun badges */}
          <Box sx={{ display: "flex", gap: 1 }}>
            {[
              { emoji: "🎓", color: YELLOW },
              { emoji: "📚", color: TEAL },
              { emoji: "🏆", color: CORAL },
              { emoji: "💡", color: PURPLE },
            ].map((e, i) => (
              <Box
                key={i}
                sx={{
                  width: 40,
                  height: 40,
                  borderRadius: "10px",
                  border: `2px solid ${e.color}40`,
                  display: "grid",
                  placeItems: "center",
                  fontSize: "1.1rem",
                  backgroundColor: `${e.color}15`,
                  animation: `floatY ${2 + i * 0.4}s ease-in-out infinite`,
                  transition: "all 0.2s ease",
                  cursor: "default",
                  "&:hover": {
                    backgroundColor: `${e.color}30`,
                    border: `2px solid ${e.color}`,
                    transform: "scale(1.1)",
                  },
                }}
              >
                {e.emoji}
              </Box>
            ))}
          </Box>
        </Grid>

        {/* Quick Links */}
        <Grid item xs={6} sm={4} md={2.5}>
          <Typography sx={{
            fontFamily: "'Fredoka One', cursive",
            fontSize: "1.15rem",
            color: YELLOW,
            mb: 2.5,
            position: "relative",
            display: "inline-block",
            "&::after": {
              content: '""',
              position: "absolute",
              bottom: -4,
              left: 0,
              width: "40%",
              height: "3px",
              backgroundColor: YELLOW,
              borderRadius: "2px",
            }
          }}>
            Quick Links
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.8 }}>
            {navItems.map((item) => (
              <Box
                key={item.id}
                component="button"
                onClick={() => onNavigate(item.id)}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                  width: "100%",
                  textAlign: "left",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  color: "rgba(255,248,240,0.75)",
                  fontFamily: "'Space Grotesk', sans-serif",
                  fontWeight: 600,
                  fontSize: "0.88rem",
                  p: 0.5,
                  pl: 0,
                  borderRadius: "6px",
                  transition: "all 0.2s ease",
                  "&:hover": {
                    color: CORAL,
                    transform: "translateX(4px)",
                    backgroundColor: "rgba(255,107,107,0.08)",
                    pl: 1,
                  },
                }}
              >
                <Box component="span" sx={{ color: YELLOW, fontSize: "0.8rem", transition: "transform 0.2s ease", ".button:hover &": { transform: "rotate(90deg)" } }}>
                  ›
                </Box>
                {item.label}
              </Box>
            ))}
          </Box>
        </Grid>

        {/* Programs */}
        <Grid item xs={6} sm={4} md={2.5}>
          <Typography sx={{
            fontFamily: "'Fredoka One', cursive",
            fontSize: "1.15rem",
            color: YELLOW,
            mb: 2.5,
            position: "relative",
            display: "inline-block",
            "&::after": {
              content: '""',
              position: "absolute",
              bottom: -4,
              left: 0,
              width: "40%",
              height: "3px",
              backgroundColor: YELLOW,
              borderRadius: "2px",
            }
          }}>
            Programs
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.8 }}>
            {["CBSE Board", "State Board", "Primary School", "Middle School", "High School", "Higher Secondary"].map((t, i) => (
              <Typography
                key={t}
                sx={{
                  color: "rgba(255,248,240,0.75)",
                  fontWeight: 600,
                  fontSize: "0.88rem",
                  fontFamily: "'Space Grotesk', sans-serif",
                  display: "flex",
                  alignItems: "center",
                  gap: 0.8,
                  transition: "all 0.2s ease",
                  cursor: "default",
                  "&:hover": {
                    color: [TEAL, CORAL, PURPLE, YELLOW, ORANGE, "#74C0FC"][i],
                    transform: "translateX(3px)",
                  }
                }}
              >
                <Box component="span" sx={{
                  width: 6,
                  height: 6,
                  borderRadius: "2px",
                  backgroundColor: [TEAL, CORAL, PURPLE, YELLOW, ORANGE, "#74C0FC"][i],
                  opacity: 0.8,
                }} />
                {t}
              </Typography>
            ))}
          </Box>
        </Grid>

        {/* Contact */}
        <Grid item xs={12} sm={4} md={3}>
          <Typography sx={{
            fontFamily: "'Fredoka One', cursive",
            fontSize: "1.15rem",
            color: YELLOW,
            mb: 2.5,
            position: "relative",
            display: "inline-block",
            "&::after": {
              content: '""',
              position: "absolute",
              bottom: -4,
              left: 0,
              width: "40%",
              height: "3px",
              backgroundColor: YELLOW,
              borderRadius: "2px",
            }
          }}>
            Get In Touch
          </Typography>

          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            {[
              {
                icon: <LocationOnRoundedIcon sx={{ fontSize: 20 }} />,
                text: schoolInfo.addressLines.join(", "),
                color: TEAL,
                bg: `${TEAL}15`,
              },
              {
                icon: <PhoneRoundedIcon sx={{ fontSize: 20 }} />,
                text: schoolInfo.phone,
                color: CORAL,
                bg: `${CORAL}15`,
              },
              {
                icon: <EmailRoundedIcon sx={{ fontSize: 20 }} />,
                text: schoolInfo.email,
                color: YELLOW,
                bg: `${YELLOW}15`,
              },
            ].map((c, i) => (
              <Box
                key={i}
                sx={{
                  display: "flex",
                  gap: 1.5,
                  alignItems: "flex-start",
                  p: 1.5,
                  borderRadius: "10px",
                  transition: "all 0.2s ease",
                  cursor: "default",
                  "&:hover": {
                    backgroundColor: c.bg,
                    transform: "translateX(3px)",
                  }
                }}
              >
                <Box sx={{
                  mt: 0.3,
                  color: c.color,
                  flexShrink: 0,
                  backgroundColor: `${c.color}20`,
                  p: 0.8,
                  borderRadius: "8px",
                  border: `1.5px solid ${c.color}40`,
                }}>
                  {c.icon}
                </Box>
                <Typography sx={{
                  color: "rgba(255,248,240,0.78)",
                  fontWeight: 600,
                  fontSize: "0.88rem",
                  lineHeight: 1.7,
                  fontFamily: "'Space Grotesk', sans-serif",
                }}>
                  {c.text}
                </Typography>
              </Box>
            ))}
          </Box>
        </Grid>
      </Grid>

      {/* Bottom bar */}
      <Box sx={{
        mt: 7,
        pt: 3.5,
        borderTop: "2px solid rgba(255,211,61,0.15)",
        display: "flex",
        flexWrap: "wrap",
        gap: 2,
        justifyContent: "space-between",
        alignItems: "center",
      }}>
        <Typography sx={{
          color: "rgba(255,248,240,0.45)",
          fontWeight: 600,
          fontSize: "0.8rem",
          fontFamily: "'Space Grotesk', sans-serif",
        }}>
          © {new Date().getFullYear()} St Lord's International Public School, Bangalore. All rights reserved.
        </Typography>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <Typography sx={{
            color: "rgba(255,248,240,0.4)",
            fontSize: "0.7rem",
            fontWeight: 600,
            fontFamily: "'Space Grotesk', sans-serif",
          }}>
            Made with
          </Typography>
          <Box sx={{ display: "flex", gap: 0.8 }}>
            {[CORAL, YELLOW, TEAL, PURPLE, ORANGE].map((c, i) => (
              <Box
                key={i}
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: i % 2 === 0 ? "50%" : "2px",
                  backgroundColor: c,
                  animation: `floatY ${1 + i * 0.3}s ease-in-out infinite`,
                  boxShadow: `0 0 6px ${c}60`,
                }}
              />
            ))}
          </Box>
        </Box>
      </Box>
    </Container>
  </Box>
);

export default Footer;